import axios from 'axios';
import Logger from './Logger';
import { sanitizeApiError } from '../utils/publicError';

class HttpClient {
  constructor(baseURL) {
    this.client = axios.create({
      baseURL: baseURL || 'http://localhost:3000/',
    });
    this.client.interceptors.response.use(
      (response) => response,
      (error) => Promise.reject(sanitizeApiError(error)),
    );
  }

  get = async (url, authToken = '') => {
    try {
      return await this.client.get(url, {
        Authorization: authToken,
      });
    } catch (err) {
      const sanitizedError = sanitizeApiError(err);
      Logger.LogError(sanitizedError);
      return sanitizedError;
    }
  };

  post = async (url, body = null, authToken = '') => {
    try {
      return await this.client.post(url, body, {
        Authorization: authToken,
      });
    } catch (err) {
      const sanitizedError = sanitizeApiError(err);
      Logger.LogError(sanitizedError);
      return sanitizedError;
    }
  };
}

export default HttpClient;
